// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/opt/buildhome/repo/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import FileTextOutlined from '/opt/buildhome/repo/node_modules/@ant-design/icons/es/icons/FileTextOutlined';
import FileSearchOutlined from '/opt/buildhome/repo/node_modules/@ant-design/icons/es/icons/FileSearchOutlined';
import BarChartOutlined from '/opt/buildhome/repo/node_modules/@ant-design/icons/es/icons/BarChartOutlined';
import DashboardOutlined from '/opt/buildhome/repo/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import CommentOutlined from '/opt/buildhome/repo/node_modules/@ant-design/icons/es/icons/CommentOutlined';
export default { SmileOutlined, FileTextOutlined, FileSearchOutlined, BarChartOutlined, DashboardOutlined, CommentOutlined };
